type ApiCallFunction = () => Promise<any>;

interface RetryOptions {
  retries: number;
  onSuccess?: (response: any) => void;
  onFailure?: (error: any) => void;
  delay?: number;
}

/**
 * retryApiCall(apiCall, options)
 *
 * Simplified API: callers must pass an options object.
 */
export async function retryApiCall(apiCall: ApiCallFunction, opts: RetryOptions): Promise<void> {
  const { retries, delay = 0, onSuccess, onFailure } = opts;

  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      const response = await apiCall();
      if (onSuccess) onSuccess(response);
      return;
    } catch (error) {
      if (attempt === retries) {
        if (onFailure) onFailure(error);
      } else if (delay > 0) {
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
    }
  }
}
